import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Delete_record extends PureComponent {
  render() {
    return (
      <div className="row" id="delete_record">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Delete Record</h2>
              <p>
                The Delete Record function allows a user to delete individual or
                bulk records. Like the Create Record and Update Record, Delete
                Record function supports up to 50 bulk record deletions per API
                call.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Delete Record Example</h2>
            </section>

            <section>
              <h3>Example 1: Delete a Single Record</h3>
              <p>This example will delete a single record with the ID 454</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeDELETE">DELETE</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>?session_id=
                <span className="jsonO">
                  &#123;&#123;session_id&#125;&#125;
                </span>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
              </div>
            </section>
            <section>
              <h3>Example 2: Delete Multiple Records</h3>
              <p>
                This example will delete 3 records with the Record ID 454, 455
                and 456.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeDELETE">DELETE</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"ids"</span>: [{" "}
                  <span className="jsonY">"454"</span>,{" "}
                  <span className="jsonY">"455"</span>,{" "}
                  <span className="jsonY">"456"</span> ]
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"deleted"</span>: [
                  <span className="jsonY">"453"</span>,{" "}
                  <span className="jsonY">"454"</span>,{" "}
                  <span className="jsonY">"455"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"failed"</span>: []
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Delete_record;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Delete_record.js